export const environment = {
  production: true,
  ambiente: "PROD",
  api: 'https://geradorpropostas.azurewebsites.net/',
  institutionalSite: 'https://enerzee.com.br',
    sistemaVO: 'https://vo.enerzee.com.br/'
  // api: "http://192.168.1.11:5001/",
};